export const SEND_TOKEN_PHONE = 'SEND_TOKEN_PHONE'
export const SEND_TOKEN_PHONE_SUCCESS = `${SEND_TOKEN_PHONE}_SUCCESS`
export const SEND_TOKEN_PHONE_FAIL = `${SEND_TOKEN_PHONE}_FAIL`

export const TOKEN_CHAGE_EMAIL = 'TOKEN_CHAGE_EMAIL'
export const TOKEN_CHAGE_EMAIL_SUCCESS = `${TOKEN_CHAGE_EMAIL}_SUCCESS`
export const TOKEN_CHAGE_EMAIL_FAIL = `${TOKEN_CHAGE_EMAIL}_FAIL`

export const fetchSendTokenPhone = data => ({
  type: SEND_TOKEN_PHONE,
  payload: {
    client: 'onboardingApi',
    request: {
      method: 'post',
      url: `/v2/sonar/token/phone`,
      data
    }
  }
})

export const fetchTokenChangeEmail = data => ({
  type: TOKEN_CHAGE_EMAIL,
  payload: {
    client: 'onboardingApi',
    request: {
      method: 'put',
      url: `/v1/api/participant/changeemail`,
      data
    }
  }
})

const INITIAL_STATE = {
  isLoading: false,
  dataResponse: null,
  errors: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SEND_TOKEN_PHONE:
      return { ...state, isLoading: true, errors: null, dataResponse: null }
    case SEND_TOKEN_PHONE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        dataResponse: action.payload.data
      }
    case SEND_TOKEN_PHONE_FAIL:
      return {
        ...state,
        isLoading: false,
        errors: action.error.response.data
      }

    case TOKEN_CHAGE_EMAIL:
      return { ...state, isLoading: true, errors: null, dataResponse: null }
    case TOKEN_CHAGE_EMAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        dataResponse: action.payload.data
      }
    case TOKEN_CHAGE_EMAIL_FAIL:
      return {
        ...state,
        isLoading: false,
        errors: action.error.response.data
      }

    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/Participant/TokenChangeEmail/ducks.js